import React from "react";
import { StyleSheet, View } from "react-native";

const classes = StyleSheet.create({
  container: {
    padding: 15,
  },
});

export default function ContactUs() {
  return (
    <View style={classes.container}>
      <h1>NCG Contact</h1>
      <p>
        To have your account data deleted, please email us at{" "}
        <b>webmaster@northcrossgroup.com</b> or call us at <b>207.699.5540</b>
      </p>
    </View>
  );
}
